// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"45":"adec2dac","349":"d81217e1","482":"66695d0d","507":"6436c45a"}[chunkId] + ".chunk.js";
};